import { isGatewayType } from './utilities/is-gateway-type';
import { eGatewayType_enum } from "@/graphql/types";
import {
  GATEWAYS_ROUTE,
  GATEWAY_CREATE_CAMERA_TO_CLOUD_ROUTE,
  GATEWAY_DEVICE_DISCOVERY_ROUTE,
  GATEWAY_VIEW_ROUTE,
  GATEWAY_VIEW_INFO_ROUTE,
  GATEWAY_VIEW_SYSTEM_ROUTE,
  GATEWAY_NETWORKING_ROUTE,
  GATEWAY_EDIT_ROUTE
} from '@/config/routes/gateways';

// middleware to prevent users from attempting to visit the edit page of Read Only Schedules
const GatewayIsNotCameraType: Middleware = async function(ctx) {
  const gatewayID = ctx?.to?.params?.[GATEWAY_VIEW_ROUTE.ROUTE_PARAM as string] || ''
  if (!(await isGatewayType(gatewayID, eGatewayType_enum.Gateway))) {
    return {
      name: GATEWAY_VIEW_ROUTE.ROUTE_NAME,
      params: {
        [GATEWAY_VIEW_ROUTE.ROUTE_PARAM]: gatewayID
      }
    };
  }
}

export default [
  /**
   * CONTAINER - All Gateway Routes will pass through this container
   *  This container is responsible for handling any global Gateway-related fetching.
   */
  {
    path: GATEWAYS_ROUTE.ROUTE_PATH,
    components: {
      default: () => import('./GatewayContainer.vue')
    },
    meta: {
      privileges: GATEWAYS_ROUTE.PRIVILEGES
    },
    children: [
      /**
       * Create Gateway
       */
      {
        path: GATEWAY_CREATE_CAMERA_TO_CLOUD_ROUTE.ROUTE_PATH,
        name: GATEWAY_CREATE_CAMERA_TO_CLOUD_ROUTE.ROUTE_NAME,
        meta: {
          privileges: GATEWAY_CREATE_CAMERA_TO_CLOUD_ROUTE.PRIVILEGES,
          scopeSelectorDisabled: false
        },
        components: {
          default: () => import('./GatewayCreateCameraToCloudPage.vue')
        }
      },

      /**
       * List of Gateways
       */
      {
        path: '',
        name: GATEWAYS_ROUTE.ROUTE_NAME,
        // meta: {},
        components: {
          default: () => import('./GatewayListPage.vue')
        }
      },

      /**
       * CONTAINER - View Gateway Routes will pass through this container
       *  Parent Route is a container to fetch the Gateway object
       *  Child routes (includes view page) will reference the Gateway object pulled in the container
       *  This container will hold some generic/global elements for all Gateway View Pages
       */
      {
        path: GATEWAY_VIEW_ROUTE.ROUTE_PATH,
        // name: GATEWAY_VIEW_ROUTE.ROUTE_NAME,
        meta: {
          privileges: GATEWAY_VIEW_ROUTE.PRIVILEGES,
          scopeSelectorDisabled: true
        },
        components: {
          default: () => import('./GatewayContainerView.vue')
        },
        children: [
          /**
           * View Gateway - Info
           */
          {
            path: GATEWAY_VIEW_INFO_ROUTE.ROUTE_PATH,
            name: GATEWAY_VIEW_INFO_ROUTE.ROUTE_NAME,
            meta: {
              privileges: GATEWAY_VIEW_INFO_ROUTE.PRIVILEGES
            },
            components: {
              default: () => import('./GatewayViewInfoPage.vue')
            }
          },
          /**
           * View Gateway - System Info
           */
          {
            path: GATEWAY_VIEW_SYSTEM_ROUTE.ROUTE_PATH,
            name: GATEWAY_VIEW_SYSTEM_ROUTE.ROUTE_NAME,
            meta: {
              privileges: GATEWAY_VIEW_SYSTEM_ROUTE.PRIVILEGES
            },
            components: {
              default: () => import('./GatewayViewSystemPage.vue')
            }
          },
          /**
           * View Gateway - System Info
           */
          {
            path: GATEWAY_NETWORKING_ROUTE.ROUTE_PATH,
            name: GATEWAY_NETWORKING_ROUTE.ROUTE_NAME,
            meta: {
              privileges: GATEWAY_NETWORKING_ROUTE.PRIVILEGES
            },
            components: {
              default: () =>
                import('./GatewayNetworkingPage.vue')
            }
          },
          /**
           * Discover Devices
           */
          {
            path: GATEWAY_DEVICE_DISCOVERY_ROUTE.ROUTE_PATH,
            name: GATEWAY_DEVICE_DISCOVERY_ROUTE.ROUTE_NAME,
            meta: {
              middleware: [GatewayIsNotCameraType],
              privileges: GATEWAY_DEVICE_DISCOVERY_ROUTE.PRIVILEGES
            },
            components: {
              default: () =>
                import('./GatewayDeviceDiscoveryPage.vue')
            }
          },
          /**
           * Edit Gateway
           */
          {
            path: GATEWAY_EDIT_ROUTE.ROUTE_PATH,
            name: GATEWAY_EDIT_ROUTE.ROUTE_NAME,
            meta: {
              privileges: GATEWAY_EDIT_ROUTE.PRIVILEGES
            },
            components: {
              default: () => import('./GatewayEditPage.vue')
            }
          }
        ]
      }
    ]
  }
];
